import { render } from "./ViewV310.vue?vue&type=template&id=22f98658&scoped=true"
import script from "./ViewV310.vue?vue&type=script&lang=js"
export * from "./ViewV310.vue?vue&type=script&lang=js"

import "./ViewV310.vue?vue&type=style&index=0&id=22f98658&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f98658"]])

export default __exports__